<template>
  <div class="favourites-content">
    <h2 class="global-title">{{ $t('mbs-select-places') }}</h2>
    <AccountCard
      v-if="list && list.length > 0"
      @clickView="clickView"
      :isFrom="isFrom"
      :list="list"
    />
    <p v-else class="no-data">{{ $t('no-place') }}</p>
  </div>
</template>

<script>
  import AccountCard from '@/components/AccountCard/index.vue';
  import { formatDateEN, formatHHmm } from '@/utils';
  import { mapState } from 'vuex';

  export default {
    components: {
      AccountCard,
    },
    data() {
      return {
        isFrom: 'places',
        list: [],
      };
    },
    computed: {
      ...mapState(['userInfo']),
    },
    mounted() {
      this.getCsList();
    },
    methods: {
      clickView(data) {
        sessionStorage.setItem('visitedData', JSON.stringify(data.item));
        const { length } = this.list;
        this.$router.push({
          path: '/account/places/visited',
          query: { currentIndex: data.index, length },
        });
      },
      // 获取消费记录列表
      async getCsList() {
        this.$loading.show();
        const { userId, sessionId } = this.userInfo;
        const data = {
          lang: localStorage.getItem('lang') || 'en_US',
          userId,
          sessionId,
        };
        try {
          const res = await this.$http.account.getCsList(data);
          if (res?.state === '11') {
            this.$loading.hide();
            if (res?.recordList?.length > 0) {
              this.list = res.recordList.map(v => {
                const date = v.date ? formatDateEN(new Date(v.date)) : '';
                const hhmm = v.date ? formatHHmm(new Date(v.date)) : '';
                return {
                  ...v,
                  name: v.restroomName,
                  businessHours: `${date} ${hhmm}`,
                  coverImg: v.image,
                };
              });
            } else {
              this.list = [];
            }
          } else {
            this.$loading.hide();
            if (res.note) {
              this.$messageModal.show({
                image: false,
                desc: res.note,
                i18nNeed: false,
                closeIcon: true,
                confirmBtn: 'ok',
                justHide: true,
              });
            }
          }
        } catch (err) {
          console.error(err);
          this.$loading.hide();
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @use '../Favourites/index.scss';
</style>
